<template>
  <div class="fts-automation-label">
    <!-- a module reference wears the module's own emoji; the generic type glyph is the fallback -->
    <fts-moji
      :emoji="getModuleEmoji"
      :size="12"
      class="automation-label__icon automation-label__icon--moji"
      v-if="getModuleEmoji"
    />
    <i class="automation-label__icon" :class="getIcon" v-else-if="getIcon"></i>
    <fts-tippy
      trigger-class="automation-label-name fts-cursor-default"
      :content="labelName"
      class="automation-label__name"
      v-if="tooltip">
      <template #trigger>{{labelName}}</template>
    </fts-tippy>
    <div class="automation-label__name" v-else>
      <div class="automation-label-name">{{labelName}}</div>
    </div>
  </div>
</template>

<script>
import commons from '../../commons/commons';
import FTSMoji from "../../elements/FTSMoji";
import FTSTippy from "../../elements/FTSTippy";

export default {
  props: {
    labelName: [String, Number],
    labelType: Number,
    labelModuleId: [String, Number],
    tooltip: Boolean,
  },
  components: {
    "fts-moji": FTSMoji,
    "fts-tippy": FTSTippy,
  },
  computed: {
    getModuleEmoji() {
      return commons.moduleEmoji(
        { type: this.labelType, moduleId: this.labelModuleId },
        this.$store.getters.workspaceModules
      );
    },
    getIcon() {
      if (this.labelType !== null && this.labelType !== undefined && this.labelType !== "") {
        return commons.informationIcon(this.labelType);
      }
    }
  }
}
</script>

<style lang="scss">
@use "./src/assets/scss/vars" as *;

.fts-automation-label {
  min-width: 0;
  display: flex;
  align-items: center;
  .automation-label__icon {
    margin-right: 0.375rem;
    color: var(--fts-default);
    &.automation-label__icon--moji {
      flex: 0 0 auto;
    }
  }
  .automation-label__name {
    min-width: 0;
    .automation-label-name {
      @include text-overflow-ellipsis;
    }
  }
}
</style>
